/**
 * Validates and sanitizes numeric input in real-time
 * @param value - The input string value
 * @param maxValue - Maximum allowed value
 * @param allowDecimals - Whether to allow decimal points (default: true)
 * @param maxDecimals - Maximum number of decimal places (default: 2)
 * @returns Sanitized string value
 */
export const validateNumericInput = (
  value: string,
  maxValue: number,
  allowDecimals: boolean = true,
  maxDecimals: number = 2
): string => {
  // Handle empty string
  if (value === '' || value === '.') {
    return value;
  }

  // Remove any non-numeric characters except decimal point
  let sanitized = value.replace(/[^\d.]/g, '');
  
  // Only allow one decimal point
  const parts = sanitized.split('.');
  if (parts.length > 2) {
    sanitized = parts[0] + '.' + parts.slice(1).join('');
  }
  
  // Limit decimal places
  if (parts.length === 2 && parts[1].length > maxDecimals) {
    sanitized = parts[0] + '.' + parts[1].substring(0, maxDecimals);
  }
  
  // Prevent typing values that exceed max
  const numValue = parseFloat(sanitized);
  if (!isNaN(numValue)) {
    // Ensure non-negative
    if (numValue < 0) {
      return '0';
    }
    
    // Prevent exceeding max
    if (numValue > maxValue) {
      return maxValue.toFixed(maxDecimals);
    }
  }
  
  return sanitized;
};

